<script>
    export let data_versions = [];
    export let tag_versions = [];
    export let data_with_tags_versions = [];

    import { getContext, createEventDispatcher } from "svelte";
    import { api_info, fetchWithAuthentication } from "../../api/client.js";

    const context = getContext(api_info);
    const dispatch = createEventDispatcher();
    import FilenameSelector from "../../components/FilenameSelector.svelte";
    import SectionButton from "../../components/SectionButton.svelte";
    import SectionTitle from "../../components/SectionTitle.svelte";
    import ResultMessage from "../../components/ResultMessage.svelte";
    import { navigate } from "svelte-navigator";

    let selectedData = ""; // { value, label}
    let selectedTag = ""; // { value, label}
    let selectedDataWithTag = ""; // { value, label}

    let taggingLoading = false;
    let taggingResponse;
    async function tagging() {
        if (selectedData && selectedTag) {
            taggingResponse = undefined;
            taggingLoading = true;
            taggingResponse = await fetchWithAuthentication(
                context,
                "/add_tag_to_dataset/",
                {
                    data_collection_name: selectedData.value,
                    tag_collection_name: selectedTag.value,
                }
            );
            taggingLoading = false;
            if (taggingResponse.status === true) {
                dispatch("new_data_with_tags");
            }
        }
    }

    function editDataWithTag() {
        if (selectedDataWithTag) {
            navigate(
                `/edit_data?db_name=data_with_tags&filename=${encodeURIComponent(
                    selectedDataWithTag.value
                )}`
            );
        }
    }
</script>

<h3>3. คำร้องและแท็ก</h3>
<form class="form-horizontal">
    <SectionTitle title="ติดแท็กในคำร้อง" />
    <FilenameSelector
        label="ข้อมูลคำร้อง"
        id="section3_request"
        items={data_versions}
        bind:value={selectedData}
    />
    <FilenameSelector
        label="ป้ายกำกับ"
        id="section3_tags"
        items={tag_versions}
        bind:value={selectedTag}
    />
    <SectionButton
        label="ติดแท็ก"
        disabled={!selectedData || !selectedTag}
        loading={taggingLoading}
        on:click={tagging}
    >
        <ResultMessage response={taggingResponse} />
    </SectionButton>

    <SectionTitle title="แก้ไขข้อมูลคำร้องติดป้ายกำกับ" />
    <FilenameSelector
        label="ข้อมูลคำร้องติดป้ายกำกับ"
        id="section3_request_tags"
        items={data_with_tags_versions}
        bind:value={selectedDataWithTag}
    />
    <SectionButton
        label="แก้ไข"
        disabled={!selectedDataWithTag}
        on:click={editDataWithTag}
    />
</form>
